/**
 * The words on the drawer's auto-advance button.
 *
 * There are two different facts here and the button has to hold both at once:
 *
 *   the MODE     what the machine is doing at all -- live (it moves projects), shadow (it only
 *                records what it would have done), off (it is not even looking). An environment
 *                switch, so it comes from the server with the project and can change any day.
 *   the STOP FLAG  whether THIS project is exempt. A person's decision, stored on the project.
 *
 * Reading the second and printing the first is how the button spent shadow week saying
 * "Auto-advance on" over a rule that has never moved anything (operator, 2026-09-18). A control
 * that claims a machine is acting when it is not is worse than no control at all, so the label
 * states the mode and the tooltip says what a click will do about it.
 *
 * Switched off there is nothing to announce -- unless someone has stopped this project, which
 * stays visible so it can be undone, and stays true for the day the mode comes back.
 *
 * The mode is UNKNOWN until the single-project read lands (the board's rows do not carry it, and
 * nobody but admin and staff is told about an internal automation at all). The button waits:
 * a late word is better than a wrong one.
 */
export function autoAdvanceChip(project, role) {
  const mode = project?.auto_advance_mode;
  const stopped = !!project?.auto_advance_disabled;
  const isStaff = role === 'admin' || role === 'staff';
  // Shown while the machine could still act on this project (Project Requested), or whenever it
  // is stopped, whatever the mode -- a stop nobody can see is a stop nobody can lift.
  const shows = isStaff && !!mode && (stopped || (mode !== 'off' && project?.admin_status_id === 1));
  const by = project?.auto_advance_disabled_by ? ` (by ${project.auto_advance_disabled_by})` : '';
  const label = stopped ? 'Auto-advance stopped' : mode === 'live' ? 'Auto-advance on' : 'Watching only';
  const stoppedTail = { shadow: ' It is watching only anyway, so nothing moves on its own yet.',
                        off: ' It is switched off anyway, so nothing moves on its own.' }[mode] || '';
  const title = stopped
    ? `Auto-advance is stopped on this project${by}.${stoppedTail} Click to allow it again.`
    : mode === 'live'
      ? 'Auto-advance may move this project to the editor once its link verifies and the event has happened. Click to stop it for this project.'
      : 'Auto-advance is watching, not acting: nothing moves on its own, and the auto-advance page records what it would have done. Click to stop this project now and it stays stopped when the rule goes live.';
  return { shows, mode, stopped, label, title };
}
